import { render } from "./SubscriptionTariffForm.vue?vue&type=template&id=151cb091"
import script from "./SubscriptionTariffForm.vue?vue&type=script&lang=js"
export * from "./SubscriptionTariffForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__